import React, { useContext, useEffect, useRef, useState } from 'react'
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from 'react-i18next';
import { useAddWorkflowGroupMutation, api } from '../../../redux/api';
import { Button, Dialog, DialogTitle, DialogActions, DialogContent, CircularProgress } from '@mui/material';
import { ParentScreenCtx } from "/src/pages/workbench_build/WorkbenchBuild";
import { treeActions } from '../../../redux/slices/treeSlice';
import TPCheckbox from "../../TemplateProperties/TPCheckbox";
import { newTemplateActions } from '../../../redux/slices/newTemplateSlice';
function DeleteInboundTemplate(props) {
    const { t } = useTranslation();
    const error = useRef();
    const dispatch = useDispatch();
    const { account } = useSelector(state => state.queryParams);
    const parentScreen = useContext(ParentScreenCtx);
    const { leftTree } = useSelector(state => state.treeData[parentScreen]);
    const currentScreen = useSelector(state => state.treeData.currentScreen)
    const [{ isLoading }] = useAddWorkflowGroupMutation();
    const selectedNode = leftTree.tree.body.selectedNode;
    // const templateName = selectedNode?.title;
    const templateName = selectedNode?.name;
    const workflowName = selectedNode?.workflowGroup;
    const [isUserSpace, setIsUserSpace] = useState(true);
    const [isServer, setIsServer] = useState(false);
    const [isUserspacecheckboxDisabled, setIsUserspaceCheckboxDisabled] = useState(false);
    const [isServerCheckboxDisabled, setIsServerCheckboxDisabled] = useState(false)
    const [loading, setLoading] = useState(false);
    const content = t('BOX_ARE_YOU_SURE_YOU_WANT_TO_DEL_').replace("{0}?", `<strong>${templateName}</strong>`)


    const handleOkClick = () => {
        if (isUserSpace || isServer) {
            error.current.textContent = ""
            setLoading(true);
            let dispatchTree = currentScreen === 'outbound' ? 'getOutboundTemplateList' : currentScreen === 'inbound' ? 'getInboundTemplateList' : 'getWorkflows'
            let dispatchReq = currentScreen === 'workflow' ? 'deleteWorkflowTemplate' : (currentScreen === 'inbound') ? 'deleteInboundTemplate' : 'deleteOutboundTemplate'
            dispatch(api.endpoints[dispatchReq].initiate({
                account,
                workflowName,
                templateName,
                is_userspace: isUserSpace,
                is_server: isServer,
                is_inbound: currentScreen === 'inbound',
                ext: selectedNode?.ext
            }, {forceRefetch: true})).then((response) => {
                if (response.error) {
                    setLoading(false);
                    error.current.textContent =
                      response?.message || response?.data?.message || t("BOX_MSG_GENERAL_ERROR");
                    return;
                  }
                if (response.data.current_state === 'SUCCESS') {
                    dispatch(api.endpoints[dispatchTree].initiate({ account }, {forceRefetch: true})).then((res) => {
                        setLoading(false);
                        dispatch(newTemplateActions.setShowAlert(true));
                        dispatch(newTemplateActions.setAlertType('success'))
                        dispatch(newTemplateActions.setAlertMessage(response.data.message));
                        dispatch(treeActions.setLeftTreeContextActionValue({
                            screen: parentScreen,
                            data: workflowName
                        }))
                        dispatch(treeActions.setShowDocFile(false));
                        
                        props.toggle();
                    })
                } else {
                    setLoading(false);
                    dispatch(newTemplateActions.setShowAlert(true));
                    dispatch(newTemplateActions.setAlertType('error'))
                    dispatch(newTemplateActions.setAlertMessage(response.data.message || t("BOX_MSG_GENERAL_ERROR")));
                    error.current.textContent = response.data.message;
                    props.toggle();
                }
            })
            .catch(error => {
                error.current.textContent = error.message || error.data.message || t("BOX_MSG_GENERAL_ERROR")
                setLoading(false);
            })
        }
    }
    const handleCancelClick = () => {
        props.toggle()
    }

    useEffect(() => {
        if (error?.current && (isServer || isUserSpace)) {
            error.current.textContent = ''
        }
    }, [isUserSpace, isServer])

    useEffect(() => {
        const { location } = selectedNode;
        if (location === 'server') {
            setIsServer(true);
            setIsUserSpace(false);
            setIsUserspaceCheckboxDisabled(true);
        } else if (location === 'both') {
            setIsServer(true);
            setIsUserSpace(true);
        } else {
            setIsUserSpace(true);
            setIsServer(false);
            setIsServerCheckboxDisabled(true);
        }
    }, [selectedNode]);

    return (
        <>
            <Dialog open={props.openModal} maxWidth="xs">
                <DialogTitle className="dialog-header">
                    <div className='title'>{t('BOX_CONFIRM')}</div>
                </DialogTitle>
                <DialogContent className='modal-content' dividers>
                    <div dangerouslySetInnerHTML={{ __html: `${content}?` }} />
                </DialogContent>
                <DialogActions>
                    <div className="flex justify-start width-100">
                        <TPCheckbox
                            label={t('USERSPACE')}
                            checked={isUserSpace}
                            disabled={isUserspacecheckboxDisabled}
                            handleCheck={(checked) => {
                                setIsUserSpace(checked);
                            }}
                        />
                        <TPCheckbox
                            label={t('SERVER')}
                            checked={isServer}
                            disabled={isServerCheckboxDisabled}
                            handleCheck={(checked) => {
                                setIsServer(checked);
                            }}
                        />
                    </div>
                    <Button
                        size="small"
                        variant="outlined"
                        color="primary"
                        disabled={loading}
                        onClick={() => {
                            handleOkClick();
                        }}>
                        {loading ? <CircularProgress size={"20px"}/> : t("BTN_YES")}
                    </Button>
                    <Button
                        size="small"
                        variant="outlined"
                        color="primary"
                        onClick={handleCancelClick}>
                        {t("BTN_NO")}
                    </Button>
                </DialogActions>
                <p className=" padding-8 error" ref={error}></p>

            </Dialog>
        </>
    )
}

export default DeleteInboundTemplate